import { render, staticRenderFns } from "./float-zhanghu.vue?vue&type=template&id=5daf24fa&"
import script from "./float-zhanghu.vue?vue&type=script&lang=js&"
export * from "./float-zhanghu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports